export const getDeliveryStatusLabel = (status) => {
    switch (status) {
        case "Delivered":
            return "Delivered";
        case "OutForDelivery":
            return "Out for delivery";
        case "InTransit":
            return "In transit";
        case "Delayed":
            return "Delayed";
        default:
            return status || "Unknown";
    }
};

export const getDeliveryStatusColor = (status) => {
    switch (status) {
        case "Delivered":
            return "green";
        case "OutForDelivery":
            return "orange";
        case "InTransit":
            return "blue";
        case "Delayed":
            return "red";
        default:
            return "gray";
    }
};

export const formatEta = (eta) => {
    if (!eta?.estimatedArrivalUtc) return "�";
    return new Date(eta.estimatedArrivalUtc).toLocaleString();
};

export const formatRemaining = (eta) => {
    if (eta?.remainingMinutes == null) return "�";
    return `${eta.remainingMinutes.toFixed(1)} min`;
};

export const formatDistance = (eta) => {
    if (eta?.distanceKm == null) return "�";
    return `${eta.distanceKm.toFixed(2)} km`;
};

export const formatSpeed = (stats) => {
    if (stats?.speedKmh == null) return "�";
    return `${stats.speedKmh.toFixed(2)} km/h`;
};